import Link from "@components/Link/Link";
import clsx from "clsx";
import React from "react";
import styles from "./C03.1_SubNavigationDE.module.scss";

interface NavLinkProps {
  linkText: string;
  openInNewTab?: boolean;
  url: string;
  contentReference?: { fields: { slug: string } };
  onNavClick: (
    e:
      | React.MouseEvent<HTMLAnchorElement>
      | React.KeyboardEvent<HTMLAnchorElement>
  ) => void;
  onNavKeyDown?: (e: React.KeyboardEvent<HTMLAnchorElement>) => void;
  customClass?: string;
  tabIndex?: number;
  isActive?: boolean;
  ariaRole?: string;
}

const NavLink: React.FC<NavLinkProps> = ({
  linkText,
  openInNewTab,
  url,
  contentReference,
  onNavClick,
  onNavKeyDown,
  customClass = "",
  tabIndex = 0,
  isActive = false,
  ariaRole = "link",
}) => {
  const linkUrl = contentReference?.fields?.slug
    ? `/${contentReference.fields.slug}`
    : url;
  const linkTarget = openInNewTab ? { target: "_blank" } : null;

  return (
    <Link
      href={linkUrl || "#"}
      {...linkTarget}
      onClick={onNavClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onNavClick(e);
        }
        onNavKeyDown?.(e);
      }}
      tabIndex={tabIndex}
      role={ariaRole}
      className={clsx(styles.link, customClass, isActive && styles.active)}
    >
      {linkText}
    </Link>
  );
};

NavLink.displayName = "NavLink";

export default NavLink;
